exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress-holder[data-v-659187e6] {\n  position: relative;\n}\n.progress-bar[data-v-659187e6] {\n  position: absolute;\n  z-index: 5;\n  opacity: 0.8;\n  margin-top: -7px;\n}\n", ""]);

// exports
